export const RRS_SMALL_LOAN = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Samle smålån og spar tusenvis – hver måned',
  url: 'https://scoopr.no/smalan',
  description:
    'Har du flere dyre smålån? Når du refinansierer og samler dem til ett lån, får du raskere kontroll og orden på økonomien din – så enkelt gjør du det.',
  datePublished: '2021-12-13T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
